import React from 'react'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import ConfirmationModal from 'components/ConfirmationModal'

import { CLAIM_BROKER_REPORTS } from 'constants'

import './styles.scss'


export default class ConsentGenerator extends BaseComponent {
  constructor() {
    super()

    this.state = {
      isSending: false,
      statusText: '',
      buttonProps: {
        disabled: false
      }
    }

    this._bind( 
      '_handleClick', '_renderContent', 
      '_sendReports', '_showConfirmSendReport',
      '_didAccept'
    )     
                
  }

  _handleClick(e) {
    e.preventDefault()
    this._showConfirmSendReport()
  }

  _sendReports() {
    this.setState({
      isSending: true,
      statusText: 'Enviando reportes ...'
    })

    request(CLAIM_BROKER_REPORTS)
      .then(({res}) => {
        this.setState({
          isSending: false,
          statusText: 'Reportes enviados exitosamente'
        })
      })
      .catch((err) => {
        this.setState({
          isSending: false,
          statusText: err
        })
      })
  }

  _didAccept(){
    if (!this.state.isSending) {
      this._sendReports()  
    }
  }

  _showConfirmSendReport(){
    var title = "Confirmación de envío de reporte para brokers"
    var message = "Esta acción enviará un reporte a cada broker habilitado."
    this.context.toggleModal(
      true,
      <ConfirmationModal 
                        _onAccept={this._didAccept.bind(this)}
                        match={this.props.match} 
                        title={title}
                        acceptLabel="Enviar"
                        message={message}
      />
    )
  }

  _downloadPdfs() {
    this._generatePdfs(this.state.results)
  }

  _renderContent() {
    const _buttonAction = this._handleClick
    const buttonValue = "Botón Azul"

    return (
      <div className="ContainerGenerator">
        <div className="Instructions">
          <button className="Button button btn btn-primary btn-big"
                  onClick={_buttonAction}>{buttonValue}
          </button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div id="ConsentGenerator">
        <div  className="StatusText"><p>{ this.state.statusText }</p></div>
        { this._renderContent() }
      </div>
    )
  }
}

ConsentGenerator.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/scenes/ConsentGenerator/index.js